import { render, staticRenderFns } from "./ProjectsEdit.vue?vue&type=template&id=50a819b3&scoped=true&"
import script from "./ProjectsEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsEdit.vue?vue&type=style&index=0&id=50a819b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a819b3",
  null
  
)

export default component.exports